import React from 'react';
import { MainContent } from '@layout';
import { Button } from '@input';
import styles from './Bio.module.scss';

export default function Bio() {
  return (
    <MainContent className={styles.wrapper}>
      <div className={styles.text}>
        <h2>Aradhna Tripati</h2>
        <div className={styles.subhead}>
          Associate Professor, UCLA
          <br />
          Founder &amp; Director, Center for Diverse Leadership in Science
        </div>
        <blockquote className={styles.quote}>
          Our shared challenge is to open up space for more people to be
          resources in the face of climate change and social inequality, so
          we can address these issues ethically, with inclusion and
          collaboration.
        </blockquote>
        <Button
          to="/about"
          className={styles.button}
          icon="scholar"
        >
          About Aradhna
        </Button>
      </div>
      <div className={styles.photo} />
    </MainContent>
  );
}
